import { ComplexValue } from 'app/types-shared';
import { DefaultFilter, FilterState } from '../types-store';

export const createDefaultFilter = (domain: ComplexValue<number>): DefaultFilter => ({
  domain,
  required: false,
  sequence: undefined,
  myValue: undefined,
  defaultValue: undefined,
  defaultValue2: undefined,
  periodPredef: undefined,
  state: FilterState.NoDefaultValue
});
